<template>
  <div class="search-input">
    <v-text-field
      solo
      hide-details
      :placeholder="placeholderText"
      label="placeholder"
      class="search-input__field"
      v-model="search"
      @keyup="searchValueEntered"
    >
      <template v-slot:prepend-inner> <icon-search class="mr-2" /> </template>
    </v-text-field>
  </div>
  <!-- prepend-inner-icon="mdi-magnify" -->
</template>

<script>
import IconSearch from "./icons/IconSearch.vue";
export default {
  components: { IconSearch },
  name: "SearchInput",
  data: () => ({
    search: ""
  }),
  props: {
    placeholderText: {
      type: String,
      default: "Search Companies"
    }
  },
  methods: {
    searchValueEntered() {
      // console.log(this.search);
      this.$emit("searchTextEntered", this.search);
    }
  }
};
</script>

<style>
.search-input .search-input__field .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #dfdfe9;
  border-radius: 10px;
  padding: 10px !important;
  height: 38px;
  font-size: 12px;
}

.search-input .search-input__field .v-input__slot input {
  color: #030134;
}

.search-input .search-input__field .v-input__icon {
  width: 15px;
  height: 15px;
}

.search-input .search-input__field .v-input__icon .v-icon {
  font-size: 15px;
  color: #030134 !important;
}

.search-input .search-input__field .v-label {
  font-size: 12px;
  line-height: 1.5;
  color: #030134;
}
.search-input .search-input__field .v-input__control {
  min-height: unset;
}
</style>
